import React, { useEffect, useState } from "react";
import { useContext } from "react";
import ReactPaginate from "react-paginate";
import { serverInfo } from "../../../App";
// import "./AuditionCardReuse.css";

const AuditionJudgeTotalVideo = (props) => {
  const { videoCdnUrl } = useContext(serverInfo);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 4;
  const { data, viewResult, viewJuryMark } = props;

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      <div className="py-3">
        <div className="row d-flex justify-content-center">
          {currentItems.map((video, index) => {
            return (
              <div
                key={index}
                className="col-md-3 p-2"
                style={{
                  height: "200px",
                }}
              >
                <video
                  height={200}
                  width="240px"
                  controls
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <source
                    src={
                      video.video != null
                        ? videoCdnUrl + video.video
                        : "https://youtu.be/dgfTiONcnTc"
                    }
                    type="video/mp4"
                  />
                </video>
              </div>
            );
          })}
        </div>
      </div>

      <div id="react-paginate">
        <ReactPaginate
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={pageCount}
          previousLabel="< previous"
          renderOnZeroPageCount={null}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageLinkClassName={"page-link"}
          previousLinkClassName={"page-link"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
        />
      </div>
    </>
  );
};

export default AuditionJudgeTotalVideo;
